import React from "react";
import { FormattedMessage } from "react-intl";
import { MenuItem } from "src/app/layout/MenuItem";
import { useAccessible } from "src/authentication/hooks/useAccessible";
import { StoresImportAccessRight } from "src/stores-import/enums/StoresImportAccessRight";
import { STORES_IMPORT_LIST_PATH } from "src/stores-import/views/StoresImportPaths";
import SubscriberExportsAccessRight from "src/subscriber-exports/enums/SubscriberExportsAccessRight";
import { SUBSCRIBERS_EXPORT_LIST_PATH } from "src/subscriber-exports/views/SubscriberExportsPaths";
import SubscribersImportAccessRight from "src/subscribers-import/enums/SubscribersImportAccessRight";
import { SUBSCRIBERS_IMPORT_LIST_PATH } from "src/subscribers-import/views/SubscribersImportPaths";

export const ImportExportMenuItem = () => {
  const canViewImportSubscribersList = useAccessible(
    SubscribersImportAccessRight.VIEW_IMPORT_SUBSCRIBERS_LIST,
  );
  const canViewExportSubscribersList = useAccessible(
    SubscriberExportsAccessRight.VIEW_EXPORT_SUBSCRIBERS_LIST,
  );
  const canViewImportStores = useAccessible(
    StoresImportAccessRight.VIEW_IMPORT_STORES,
  );
  if (canViewImportSubscribersList) {
    return (
      <MenuItem
        pathName={SUBSCRIBERS_IMPORT_LIST_PATH}
        label={<FormattedMessage id="imports_exports" />}
      />
    );
  }
  if (canViewExportSubscribersList) {
    return (
      <MenuItem
        pathName={SUBSCRIBERS_EXPORT_LIST_PATH}
        label={<FormattedMessage id="imports_exports" />}
      />
    );
  }
  if (canViewImportStores) {
    return (
      <MenuItem
        pathName={STORES_IMPORT_LIST_PATH}
        label={<FormattedMessage id="imports_exports" />}
      />
    );
  }
  return null;
};
